module.exports = __webpack_public_path__ + "img/logo-min-white.df4ab79a.png";